import AedIcon from "./aedIcon";
import BicycleIcon from "./bicycleIcon";

/**
 * アイコン名からコンポーネントへのマッピング。
 * campus_config.json の displaySettings[].icon に対応するキーを定義する。
 * 新しいアイコンを追加する場合はここにエントリを追加するだけで良い。
 */
const iconRegistry = {
  aed: AedIcon,
  bicycle: BicycleIcon,
};

/**
 * アイコン名からReactコンポーネントを取得する。
 * 未登録の場合はnullを返す。
 * @param {string} name - campus_config.json の icon フィールド値
 * @returns {React.ComponentType|null}
 */
export function getIconComponent(name) {
  return iconRegistry[name] || null;
}

export default iconRegistry;
